import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: 'Home', path: '/' },
    { label: 'Blog', path: '/blog' },
    { label: 'About', path: '/about' },
    { label: 'Contact', path: '/contact' },
  ];

  const popularCategories = [
    { label: 'Smart Betting Strategies', path: '/category/smart-betting-strategies' },
    { label: 'Business & Wealth', path: '/category/business-wealth' },
    { label: 'Health & Wellness', path: '/category/health-fitness-wellness' },
    { label: 'Travel & Adventure', path: '/category/travel-adventure' },
    { label: 'Digital Marketing', path: '/category/digital-business-marketing' },
  ];

  const resources = [
    { label: 'Guides', path: '/guides' },
    { label: 'Reviews', path: '/reviews' },
    { label: 'Comparisons', path: '/comparisons' },
  ];

  const legal = [
    { label: 'Affiliate Disclosure', path: '/affiliate-disclosure' },
    { label: 'Privacy Policy', path: '/privacy' },
    { label: 'Terms of Service', path: '/terms' },
  ];

  return (
    <footer className="bg-gradient-to-br from-teal-600 via-teal-700 to-teal-800 text-white relative overflow-hidden">
      {/* Decorative Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="relative">
        {/* Upper Footer */}
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-12 py-10 md:py-16 lg:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-12 lg:gap-16">
            {/* Left Zone - Newsletter */}
            <div className="lg:col-span-4">
              <Link to="/" className="flex items-center gap-2 mb-4 md:mb-6">
                <img 
                  src="https://public.readdy.ai/ai/img_res/eb40fa79-3681-4e55-a899-5bfa4896fbbe.png" 
                  alt="Simsers Affiliate" 
                  className="h-8 w-8 md:h-10 md:w-10 object-contain brightness-0 invert"
                />
                <span className="text-lg md:text-xl font-semibold whitespace-nowrap">Simsers Affiliate</span>
              </Link>
              
              <p className="text-2xl md:text-3xl lg:text-4xl font-crimson font-semibold mb-6 md:mb-8 leading-tight">
                Stay informed across every niche
              </p>

              <div className="flex gap-2 md:gap-3">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="flex-1 px-4 md:px-5 py-2.5 md:py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-white/60 focus:outline-none focus:border-white/40 transition-colors text-sm md:text-base"
                />
                <button className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center bg-orange-500 hover:bg-orange-600 rounded-lg transition-colors cursor-pointer whitespace-nowrap flex-shrink-0">
                  <i className="ri-notification-line text-lg md:text-xl"></i>
                </button>
              </div>
            </div>

            {/* Right Zone - Navigation Grid */}
            <div className="lg:col-span-8 grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 lg:gap-12">
              {/* Quick Links */}
              <div>
                <h4 className="text-sm md:text-base font-semibold mb-3 md:mb-4 whitespace-nowrap">Quick Links</h4>
                <ul className="space-y-2 md:space-y-3">
                  {quickLinks.map((link, index) => (
                    <li key={index}>
                      <Link
                        to={link.path}
                        className="text-sm md:text-base text-white/80 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Popular */}
              <div>
                <h4 className="text-sm md:text-base font-semibold mb-3 md:mb-4 whitespace-nowrap">Popular</h4>
                <ul className="space-y-2 md:space-y-3">
                  {popularCategories.map((link, index) => (
                    <li key={index}>
                      <Link
                        to={link.path}
                        className="text-sm md:text-base text-white/80 hover:text-white transition-colors cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Resources */}
              <div>
                <h4 className="text-sm md:text-base font-semibold mb-3 md:mb-4 whitespace-nowrap">Resources</h4>
                <ul className="space-y-2 md:space-y-3">
                  {resources.map((link, index) => (
                    <li key={index}>
                      <Link
                        to={link.path}
                        className="text-sm md:text-base text-white/80 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Legal */}
              <div>
                <h4 className="text-sm md:text-base font-semibold mb-3 md:mb-4 whitespace-nowrap">Legal</h4>
                <ul className="space-y-2 md:space-y-3">
                  {legal.map((link, index) => (
                    <li key={index}>
                      <Link
                        to={link.path}
                        className="text-sm md:text-base text-white/80 hover:text-white transition-colors cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Lower Footer */}
        <div className="border-t border-white/10">
          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-12 py-5 md:py-6">
            <div className="flex flex-col lg:flex-row items-center justify-between gap-4 md:gap-6">
              {/* Copyright */}
              <p className="text-xs md:text-sm text-white/70 text-center lg:text-left">
                © {currentYear} Simsers Affiliate. All rights reserved.
              </p>

              {/* Social Icons */}
              <div className="flex items-center gap-3 md:gap-4">
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center border border-white/20 rounded-lg hover:bg-white/10 transition-colors cursor-pointer"
                  aria-label="Facebook"
                >
                  <i className="ri-facebook-line text-base md:text-lg"></i>
                </a>
                <a
                  href="https://twitter.com"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center border border-white/20 rounded-lg hover:bg-white/10 transition-colors cursor-pointer"
                  aria-label="Twitter"
                >
                  <i className="ri-twitter-x-line text-base md:text-lg"></i>
                </a>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center border border-white/20 rounded-lg hover:bg-white/10 transition-colors cursor-pointer"
                  aria-label="Instagram"
                >
                  <i className="ri-instagram-line text-base md:text-lg"></i>
                </a>
                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center border border-white/20 rounded-lg hover:bg-white/10 transition-colors cursor-pointer"
                  aria-label="LinkedIn"
                >
                  <i className="ri-linkedin-line text-base md:text-lg"></i>
                </a>
              </div>

              {/* Affiliate Disclosure Link */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
